// extracted by mini-css-extract-plugin
export default {"registerWrapper":"RegisterScreen_registerWrapper__pbZq8","appearAnimation":"RegisterScreen_appearAnimation__p6M8i","title":"RegisterScreen_title__gWqW9"};